import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import styles from "./userDashboardHome.module.css";
import toast from "react-hot-toast";
import PaymentModals from "../../pages/models/PaymentModals";
import { render } from "@testing-library/react";
import UserInfoModals from "../../pages/models/UserInfoModals";
import {
  Box, CircularProgress, Typography,
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import axiosConfig from "../../axios/axiosConfig";
const TableSection = ({ title, columns, data, onRowClick, isClickable }) => {
  return (
    <div className={styles.section}>
      {title && <h3>{title}</h3>}
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i}>{col?.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr
                key={idx}
                onClick={isClickable ? () => onRowClick(row) : undefined}
                className={isClickable ? styles.clickableRow : ""}
              >
                {columns.map((col, i) => (
                  <td key={i}>{col.render(row)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const UserDashboardHome = () => {
  const [phone, setPhone] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [addonDetails, setAddonDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [editedPayment, setEditedPayment] = useState(null);
  const [openUserModal, setOpenUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [subscriptionLoadingId, setSubscriptionLoadingId] = useState(null);
  const [invoiceTableLoading, setInvoiceTableLoading] = useState(false);

  const [cancelMandateModal, setCancelMandateModal] = useState({ open: false, razorpay_subscription_id: "" });
  const [cancelReason, setCancelReason] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);

  const [planChangeModal, setPlanChangeModal] = useState({ open: false, subscription: null });
  const [activePlansList, setActivePlansList] = useState([]);
  const [planChangeForm, setPlanChangeForm] = useState({ new_plan_id: "", new_expiry_date: "", alerts: "", remark: "" });
  const [planChangeLoading, setPlanChangeLoading] = useState(false);

  const [updateSubModal, setUpdateSubModal] = useState({ open: false, subscription: null });
  const [updateSubForm, setUpdateSubForm] = useState({
    plan_id: "",
    start_date: "",
    next_billing_date: "",
    expiry_date: "",
    credits: "",
    active: true,
  });
  const [updateSubLoading, setUpdateSubLoading] = useState(false);
  const [plansLoading, setPlansLoading] = useState(false);

  const [nameResults, setNameResults] = useState([]);
  const [showNameDropdown, setShowNameDropdown] = useState(false);
  const [nameSearchLoading, setNameSearchLoading] = useState(false);
  const skipNameSearchRef = useRef(false);

  const handleCancelMandate = async () => {
    if (!cancelReason.trim()) {
      toast.error("Please enter a cancellation reason");
      return;
    }
    setCancelLoading(true);
    try {
      await axiosConfig({
        method: "post",
        url: "/subscription/cancel-user-subscription",
        data: {
          razorpay_subscription_id: cancelMandateModal.razorpay_subscription_id,
          cancellation_reason: cancelReason.trim(),
        },
      });
      toast.success("Mandate cancelled successfully");
      setCancelMandateModal({ open: false, razorpay_subscription_id: "" });
      setCancelReason("");
    } catch (err) {
      const apiMsg =
        err?.response?.data?.response ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to cancel mandate";
      toast.error(apiMsg);
    } finally {
      setCancelLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    return date.toISOString().split("T")[0];
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    const d = date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" });
    const t = date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
    return `${d} || ${t}`;
  };
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userType = storedUser?.userDetails?.user_type;

  const fetchData = async (phoneOverride) => {
    const phoneToSearch = phoneOverride || phone;
    if (!phoneToSearch) {
      setError("Please enter a phone number");
      return;
    }

    setLoading(true);
    setError("");
    setUserDetails([]);
    setPaymentDetails([]);
    setSubscriptionDetails([]);
    setAddonDetails([]);
    setSelectedPayment(null);
    try {
      const response = await axiosConfig({
        method: "get",
        url: `/tnibroadmin/user-plan-details`,
        params: { phoneno: phoneToSearch },
      });
      // if (response.data.results.status === 'success') {
      const { user_details, payment_details, user_subscription, user_subscription_addon } =
        response.data.result;
      setUserDetails(user_details);
      setPaymentDetails(payment_details);
      setSubscriptionDetails(user_subscription);
      setAddonDetails(user_subscription_addon ?? []);
      // }
      //  else {
      //   setError('No data found');
      // }
    } catch (err) {
      setError(err.response.data.response);
    } finally {
      setLoading(false);
    }
  };

  // Debounced name search on the same input — fires alongside the phone search,
  // shows a dropdown of matching users; harmless no-op if someone types a phone number.
  useEffect(() => {
    if (skipNameSearchRef.current) {
      skipNameSearchRef.current = false;
      return;
    }
    const query = phone.trim();
    if (query.length < 2) {
      setNameResults([]);
      setShowNameDropdown(false);
      return;
    }
    const timer = setTimeout(async () => {
      setNameSearchLoading(true);
      try {
        const res = await axiosConfig({
          method: "get",
          url: `/tnibroadmin/user-detail-by-name/`,
          params: { name: query },
        });
        const results = Array.isArray(res.data?.response)
          ? res.data.response
          : Array.isArray(res.data?.result)
            ? res.data.result
            : Array.isArray(res.data)
              ? res.data
              : [];
        setNameResults(results);
        setShowNameDropdown(results.length > 0);
      } catch (err) {
        setNameResults([]);
        setShowNameDropdown(false);
      } finally {
        setNameSearchLoading(false);
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [phone]);

  const getResultName = (u) => u.name || u.username || u.full_name || "—";
  const getResultPhone = (u) => u.phone_number || u.phoneno || u.phone || u.mobile || "";

  const handleSelectNameResult = (u) => {
    const selectedPhone = getResultPhone(u);
    setShowNameDropdown(false);
    if (!selectedPhone) {
      toast.error("No phone number found for this user");
      return;
    }
    skipNameSearchRef.current = true;
    setPhone(selectedPhone);
    fetchData(selectedPhone);
  };

  const handleRowClick = async (row) => {
    try {
      const response = await axiosConfig({
        method: "get",
        url: `/payment/payment-detail`,
        params: { id: row.id },
      });
      setSelectedPayment(response.data?.response[0]);
      setEditedPayment(response.data?.response[0]);
      setOpenModal(true);
    } catch (err) {
      alert("Error fetching payment detail");
    }
  };
  const handlePostPayment = async () => {
    if (!selectedPayment) return;
    try {
      await axiosConfig({
        method: "post",
        url: "/payment/payment-detail",
        data: editedPayment,
      });
      toast.success("Payment details updated");
      setOpenModal(false);
      await fetchData();
    } catch (err) {
      alert("Failed to post payment details");
      toast.error("Failed to post payment details");
    }
  };

  const handleCreateSubscription = async (paymentId, userId) => {
    try {
      setSubscriptionLoadingId(paymentId);
      const payload = {
        id: paymentId,
        userid: userId,
      };

      await axiosConfig({
        method: "post",
        url: "/payment/create-subscription-by-payment",
        data: payload,
      });
      toast.success("Subscription created successfully");
      await fetchData();
    } catch (err) {
      const msg = err?.response?.data?.response || "Something went wrong";
      toast.error(msg);
    } finally {
      setSubscriptionLoadingId(null);
    }
  };
  const handleCreateInvoice = async ({
    userid,
    plan_id,
    payment_id,
    coupon_id,
  }) => {
    try {
      setInvoiceTableLoading(true);
      const payload = {
        userid,
        plan_id,
        payment_id,
      };
      if (coupon_id) {
        payload.coupon_id = coupon_id;
      }
      const res = await axiosConfig({
        method: "post",
        url: `/payment/create-invoice`,
        data: payload,
      });
      if (res.data?.status === "success") {
        toast.success("Invoice created successfully");
        await fetchData();
      } else {
        toast.error(res.data?.response || "Failed to create invoice");
      }
    } catch (error) {
      const msg =
        error?.response?.data?.response ||
        "Server error while creating invoice";
      toast.error(msg);
      console.error("Create Invoice Error:", error);
    } finally {
      setInvoiceTableLoading(false);
    }
  };

  const handleDownloadInvoice = async (payload) => {
    const { userId, paymentId } = payload;
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.access_token;
    if (!token) {
      toast.error("User not authenticated");
      return;
    }

    try {
      const response = await axiosConfig({
        method: "get",
        url: `/payment/download-invoice`,
        params: { userid: userId, payment_id: paymentId },
        headers: { Authorization: `Bearer ${token}` },
      });
      const filePath = await response?.data?.data?.file_url;
      if (!filePath) {
        toast.error("PDF file not found in response.");
        return;
      }

      window.open(filePath, "_blank");
    } catch (error) {
      console.error("Invoice download failed:", error);
      const errMsg =
        error?.response?.data?.response ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to download invoice.";

      toast.error(errMsg);
    }
  };

  const handleUserInfoRow = async (row) => {
    try {
      const response = await axiosConfig({
        method: "get", 
        url: `/user/userprofile`,
        params: { userid: row.id },
      });
      const userData = response?.data?.response;
      if (userData) {
        setSelectedUser(userData);
        setOpenUserModal(true);
      } else {
        toast.error("User Details not found");
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      const errMsg =
        error?.response?.data?.response ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch user profile.";
      toast.error(errMsg);
    }
  };

  const handleOpenPlanChangeModal = async (subscription) => {
    setPlanChangeForm({ new_plan_id: "", new_expiry_date: "", alerts: "", remark: "" });
    setPlanChangeModal({ open: true, subscription });
    try {
      setPlansLoading(true);
      const response = await axiosConfig({ method: "get", url: "/payment/plans" });
      if (response?.data?.status === "success") {
        setActivePlansList(response.data.response.data || []);
      } else {
        toast.error("Failed to fetch plans");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch plans");
    } finally {
      setPlansLoading(false);
    }
  };

  const handleClosePlanChangeModal = () => {
    setPlanChangeModal({ open: false, subscription: null });
    setActivePlansList([]);
  };

  const handleOpenUpdateSubModal = async (subscription) => {
    setUpdateSubForm({
      plan_id: "",
      start_date: subscription?.start_date ? subscription.start_date.slice(0, 10) : "",
      next_billing_date: subscription?.next_billing_date ? subscription.next_billing_date.slice(0, 10) : "",
      expiry_date: subscription?.expiry_date ? subscription.expiry_date.slice(0, 10) : "",
      credits: subscription?.credits ?? "",
      active: !!subscription?.active,
    });
    setUpdateSubModal({ open: true, subscription });
    try {
      setPlansLoading(true);
      const response = await axiosConfig({ method: "get", url: "/payment/plans" });
      if (response?.data?.status === "success") {
        const plans = response.data.response.data || [];
        setActivePlansList(plans);
        // Row only carries plan_name (no plan_id), so match it against the
        // plans list by name to resolve the id the select needs as its value.
        const matchedPlan = plans.find(
          (p) => (p.plan_name || p.name) === subscription?.plan_name
        );
        if (matchedPlan) {
          setUpdateSubForm((f) => ({ ...f, plan_id: matchedPlan.id }));
        }
      } else {
        toast.error("Failed to fetch plans");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch plans");
    } finally {
      setPlansLoading(false);
    }
  };

  const handleCloseUpdateSubModal = () => {
    setUpdateSubModal({ open: false, subscription: null });
    setActivePlansList([]);
  };

  const handleSubmitUpdateSubscription = async () => {
    if (!updateSubForm.plan_id || !updateSubForm.next_billing_date || !updateSubForm.expiry_date) {
      toast.error("Please fill all required fields");
      return;
    }
    try {
      setUpdateSubLoading(true);
      const subscriptionId = updateSubModal.subscription?.sub_id;
      const userId = userDetails[0]?.id;
      const response = await axiosConfig({
        method: "post",
        url: "/subscription/update-user-subscription/",
        data: {
          id: subscriptionId,
          user_id: userId,
          plan_id: Number(updateSubForm.plan_id),
          start_date: updateSubForm.start_date,
          next_billing_date: updateSubForm.next_billing_date,
          expiry_date: updateSubForm.expiry_date,
          credits: Number(updateSubForm.credits) || 0,
          active: updateSubForm.active,
        },
      });
      const successMsg =
        typeof response?.data?.message === "string"
          ? response.data.message
          : typeof response?.data?.response === "string"
            ? response.data.response
            : "Subscription updated successfully";
      toast.success(successMsg);
      handleCloseUpdateSubModal();
      await fetchData();
    } catch (err) {
      const errMsg = err?.response?.data?.message ?? err?.response?.data?.response;
      toast.error(typeof errMsg === "string" ? errMsg : "Failed to update subscription");
    } finally {
      setUpdateSubLoading(false);
    }
  };

  const handleSubmitPlanChange = async () => {
    if (!planChangeForm.new_plan_id || !planChangeForm.new_expiry_date || !planChangeForm.remark.trim()) {
      toast.error("Please fill all required fields including remark");
      return;
    }
    try {
      setPlanChangeLoading(true);
      const changeFor = userDetails[0]?.id;
      const changeBy = storedUser?.userDetails?.id;
      const response = await axiosConfig({
        method: "post",
        url: "/subscription/user-plan-change/",
        data: {
          change_for: changeFor,
          change_by: changeBy,
          new_plan_id: Number(planChangeForm.new_plan_id),
          new_expiry_date: planChangeForm.new_expiry_date,
          alerts: Number(planChangeForm.alerts) || 0,
          remark: planChangeForm.remark || "",
        },
      });
      toast.success(response?.data?.message || "Plan change request accepted");
      handleClosePlanChangeModal();
      await fetchData();
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.response || "Failed to change plan");
    } finally {
      setPlanChangeLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      
      {/* Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          px: 3,
          py: 2,
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          boxShadow: "0 4px 20px rgba(26,32,53,0.3)",
        }}
      >
        <ManageSearchIcon sx={{ color: "#eef2f7", fontSize: 26 }} />
        <Box>
          <Typography sx={{ color: "#ffffff", fontWeight: 700, fontSize: 18, lineHeight: 1.2 }}>
            Search User by Phone or Name
          </Typography>
          <Typography sx={{ color: "#eef2f7", fontSize: 12 }}>
            Lookup user info, payments and subscriptions
          </Typography>
        </Box>
      </Box>

      <Box sx={{ background: "#ffffff", borderRadius: "12px", p: 2.5, mb: 3, boxShadow: "0 1px 6px rgba(0,0,0,0.07)", border: "1px solid #e2e8f0" }}>
        <div className={styles.inputGroup} style={{ position: "relative" }}>
          <input
            type="text"
            placeholder="Enter Phone Number or Name"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onFocus={() => setShowNameDropdown(nameResults.length > 0)}
            onBlur={() => setTimeout(() => setShowNameDropdown(false), 150)}
            className={styles.input}
          />
          <button color="success" onClick={() => fetchData()} className={styles.button}>
            Search
          </button>

          {showNameDropdown && (
            <Box
              sx={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                width: "100%",
                maxWidth: 320,
                maxHeight: 260,
                overflowY: "auto",
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                zIndex: 10,
              }}
            >
              {nameSearchLoading ? (
                <Box sx={{ p: 1.5, display: "flex", justifyContent: "center" }}>
                  <CircularProgress size={18} />
                </Box>
              ) : (
                nameResults.map((u, idx) => (
                  <Box
                    key={u.id ?? idx}
                    onMouseDown={() => handleSelectNameResult(u)}
                    sx={{
                      px: 1.5, py: 1, cursor: "pointer",
                      borderBottom: idx !== nameResults.length - 1 ? "1px solid #f1f5f9" : "none",
                      "&:hover": { background: "#f0fdf4" },
                    }}
                  >
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{getResultName(u)}</Typography>
                    <Typography sx={{ fontSize: 11.5, color: "#64748b" }}>{getResultPhone(u) || "No phone on file"}</Typography>
                  </Box>
                ))
              )}
            </Box>
          )}
        </div>
      </Box>

      {loading && <p>Loading...</p>}
      {error && <p className={styles.error}>{error}</p>}

      {userDetails?.length > 0 && (
        <Box
          sx={{
            background: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            border: "1px solid #e2e8f0",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <Box sx={{ px: 2.5, py: 1.5, borderBottom: "1px solid #e2e8f0", background: "#04343a" }}>
            <Typography sx={{ color: "#e2e8f0", fontWeight: 700, fontSize: 14 }}>User Info</Typography>
          </Box>
          <TableSection
          title=""
          data={userDetails}
          isClickable={userType === "Admin" || userType === "Marketing"}
          onRowClick={handleUserInfoRow}
          columns={[
            { header: "User ID", render: (u) => u.id },
            { header: "Phone", render: (u) => u.phone_number },
            { header: "Name", render: (u) => u.name },
            { header: "User Type", render: (u) => u.user_type },
            { header: "Status", render: (u) => u.status },
            { header: "Date Joined", render: (u) => formatDate(u.date_joined) },
            { header: "Last Login", render: (u) => formatDateTime(u.last_login) },
            { header: "Referral Code", render: (u) => u.referralcode || "N/A" },
            { header: "Consent Status", render: (u) => u.consent_status },
          ]}
        />
        </Box>
      )}

      {paymentDetails?.length > 0 && (
        <Box
          sx={{
            background: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            border: "1px solid #e2e8f0",
            overflow: "hidden",
            mb: 3,
            position: "relative",
          }}
        >
          <Box
            sx={{
              px: 2.5,
              py: 1.5,
              borderBottom: "1px solid #e2e8f0",
              background: "#04343a",
            }}
          >
            <Typography sx={{ color: "#e2e8f0", fontWeight: 700, fontSize: 14 }}>
              Payment History
            </Typography>
          </Box>
          {invoiceTableLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255,255,255,0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2,
              }}
            >
              <CircularProgress size={48} />
            </div>
          )}
          <TableSection
            title=""
            data={paymentDetails}
            onRowClick={handleRowClick}
            isClickable={userType === "Admin"}
            columns={[
              { header: "Payment ID", render: (p) => p.id || "N/A" },
              { header: "Plan Name", render: (p) => p.plan || "N/A" },
              { header: "Plan ID", render: (p) => p.plan_id || "N/A" },
              {
                header: "Order ID",
                render: (p) => p.provider_order_id || "N/A",
              },
              {
                header: "Razorpay Payment ID",
                render: (p) => p.razorpay_payment_id || "N/A",
              },
              {
                header: "Status",
                render: (p) => {
                  const status = String(p.payment_status).toLowerCase();
                  return status === "success" || status === "true" ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      Success
                    </span>
                  ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      Failed
                    </span>
                  );
                },
              },
              { header: "Amount", render: (p) => p.amount },
              {
                header: "Start Date",
                render: (p) => formatDate(p.payment_date),
              },
              {
                header: "Expiry Date",
                render: (p) =>
                  p.payment_end_date ? formatDate(p.payment_end_date) : "NA",
              },
              { header: "Total Alerts", render: (p) => p.total_alerts },
              { header: "Used Alerts", render: (p) => p.used_alert },
              {
                header: "Refund Status",
                render: (p) =>
                  p.refund_status === true ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
                  ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>No</span>
                  ),
              },
              ...(userType === "Admin" || userType === "Marketing"
                ? [
                    {
                      header: "Actions",
                      render: (p) => {
                        const userId = userDetails[0]?.id;
                        return (
                          <>
                            {p.payment_status === true && (
                              <button
                                className={styles.button}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const userId = userDetails[0]?.id;
                                  if (userId) {
                                    handleCreateSubscription(p.id, userId);
                                  } else {
                                    toast.error("User ID not found");
                                  }
                                }}
                                disabled={subscriptionLoadingId === p.id}
                              >
                                {subscriptionLoadingId === p.id ? (
                                  <CircularProgress size={24} variant="solid" />
                                ) : (
                                  " Make Subscription"
                                )}
                              </button>
                            )}

                            {/* ✅ Create Invoice Button */}
                            {/* {p.payment_status === true &&
                              p.invoice_id === null &&
                              p.invoice_numebr === null && (
                                <button
                                  className={styles.button}
                                  // style={{
                                  //   marginLeft: "8px",
                                  //   backgroundColor: "#4caf50",
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const payload = {
                                      userid: Number(userDetails[0].id),
                                      plan_id: Number(p.plan_id),
                                      payment_id: Number(p.id),
                                      coupon_id: p.coupon_id,
                                    };
                                    handleCreateInvoice(payload);
                                  }}
                                  disabled={invoiceTableLoading}
                                >
                                  {invoiceTableLoading ? (
                                    <CircularProgress
                                      size={20}
                                      sx={{ color: "#fff" }}
                                    />
                                  ) : (
                                    "Create Invoice"
                                  )}
                                </button>
                              )} */}

                            {/* ✅ Invoice download */}
                            {p.payment_status === true &&
                              p.invoice_id &&
                              p.invoice_numebr &&
                              userId &&
                              p.id && (
                                <>
                                  <button
                                    className={styles.button}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const params = {
                                        userId: userId,
                                        paymentId: p?.id,
                                      };
                                      handleDownloadInvoice(params);
                                    }}
                                  >
                                    Download Invoice
                                  </button>
                                </>
                              )}
                          </>
                        );
                      },
                    },
                  ]
                : []),
            ]}
          />
        </Box>
      )}
      {selectedUser && (
        <UserInfoModals
          open={openUserModal}
          onClose={() => setOpenUserModal(false)}
          user={selectedUser}
          onUserUpdate={fetchData}
        />
      )}
      {selectedPayment && (
        <PaymentModals
          open={openModal}
          onClose={() => setOpenModal(false)}
          editedPayment={editedPayment}
          setEditedPayment={setEditedPayment}
          handlePostPayment={handlePostPayment}
        />
      )}
      {subscriptionDetails?.length > 0 && (
        <Box
          sx={{
            background: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            border: "1px solid #e2e8f0",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <Box sx={{ px: 2.5, py: 1.5, borderBottom: "1px solid #e2e8f0", background: "#04343a" }}>
            <Typography sx={{ color: "#e2e8f0", fontWeight: 700, fontSize: 14 }}>Subscription Info</Typography>
          </Box>
          <TableSection
          title=""
          data={subscriptionDetails}
          columns={[
            { header: "Plan Name", render: (s) => s.plan_name },
            { header: "Subscription ID", render: (s) => s.sub_id },
            { header: "Razorpay Subscription ID", render: (s) => s.razorpay_subscription_id },
            { header: "Start Date", render: (s) => formatDate(s.start_date) },
            { header: "Next Billing", render: (s) => formatDate(s.next_billing_date) },
            { header: "Expiry Date", render: (s) => formatDate(s.expiry_date) },
            { header: "Credits", render: (s) => s.credits },
            { header: "Auto Pay", render: (s) => (s.autopay ? "Yes" : "No") },
            { header: "Status", render: (s) => (s.active ? "Active" : "Inactive") },
            {
              header: "Actions",
              render: (s) => {
                console.log("subscription row:", s);
                return (
                <Box sx={{ display: "flex", gap: 1, flexWrap: "nowrap" }}>
                  {/* <button
                    className={styles.button}
                    style={{ whiteSpace: "nowrap" }}
                    onClick={(e) => { e.stopPropagation(); handleOpenPlanChangeModal(s); }}
                  >
                    Plan Change
                  </button> */}
                  <button
                    className={styles.button}
                    style={{ whiteSpace: "nowrap" }}
                    onClick={(e) => { e.stopPropagation(); handleOpenUpdateSubModal(s); }}
                  >
                    Update Subscription
                  </button>
                  {s.razorpay_subscription_id && (
                    <button
                      className={styles.button}
                      style={{ whiteSpace: "nowrap", background: "#dc2626" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCancelMandateModal({ open: true, razorpay_subscription_id: s.razorpay_subscription_id });
                        setCancelReason("");
                      }}
                    >
                      Cancel Mandate
                    </button>
                  )}
                </Box>
                );
              },
            },
          ]}
          />
        </Box>
      )}

      {addonDetails?.length > 0 && (
        <Box
          sx={{
            background: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            border: "1px solid #e2e8f0",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <Box sx={{ px: 2.5, py: 1.5, borderBottom: "1px solid #e2e8f0", background: "#04343a" }}>
            <Typography sx={{ color: "#e2e8f0", fontWeight: 700, fontSize: 14 }}>Subscription Add-ons</Typography>
          </Box>
          <TableSection
            title=""
            data={addonDetails}
            columns={[
              { header: "Plan Name",   render: (a) => a.plan_name },
              { header: "Payment ID",  render: (a) => a.payment_id ?? "N/A" },
              { header: "Start Date",  render: (a) => formatDate(a.start_date) },
              { header: "Expiry Date", render: (a) => formatDate(a.expiry_date) },
              { header: "Next Billing",render: (a) => formatDate(a.next_billing_date) },
              { header: "Auto Pay",    render: (a) => (a.auto_pay ? "Yes" : "No") },
              { header: "Status",      render: (a) => (a.active ? "Active" : "Inactive") },
            ]}
          />
        </Box>
      )}
      {/* Plan Change Modal */}
      {planChangeModal.open && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1400,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={handleClosePlanChangeModal}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "100%",
              maxWidth: 520,
              boxShadow: "0 8px 32px rgba(4,52,58,0.2)",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{ background: "#04343a", padding: "14px 20px" }}>
              <p style={{ margin: 0, color: "#fff", fontWeight: 700, fontSize: 15 }}>Plan Change</p>
            </div>

            <div style={{ padding: "20px 24px" }}>
              {/* Current Subscription Summary Row */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: 8,
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: 8,
                  padding: "10px 14px",
                  marginBottom: 20,
                }}
              >
                {[
                  { label: "Plan Name", value: planChangeModal.subscription?.plan_name },
                  { label: "Start Date", value: formatDate(planChangeModal.subscription?.start_date) },
                  { label: "Expiry Date", value: formatDate(planChangeModal.subscription?.next_billing_date) },
                  { label: "Credits", value: planChangeModal.subscription?.credits ?? "—" },
                ].map(({ label, value }) => (
                  <div key={label} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0, fontSize: 10, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</p>
                    <p style={{ margin: "2px 0 0", fontSize: 13, fontWeight: 700, color: "#04343a" }}>{value || "—"}</p>
                  </div>
                ))}
              </div>

              {/* New Plan Dropdown */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                  Select New Plan
                </label>
                <select
                  value={planChangeForm.new_plan_id}
                  onChange={(e) => setPlanChangeForm((f) => ({ ...f, new_plan_id: e.target.value }))}
                  disabled={plansLoading}
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    border: "1px solid #cbd5e1",
                    borderRadius: 6,
                    fontSize: 13,
                    outline: "none",
                    background: plansLoading ? "#f8fafc" : "#fff",
                    color: "#1e293b",
                  }}
                >
                  <option value="">{plansLoading ? "Loading plans..." : "— Select Plan —"}</option>
                  {activePlansList.map((plan) => (
                    <option key={plan.id} value={plan.id}>
                      {plan.plan_name || plan.name} {plan.plan_code ? `[${plan.plan_code}]` : ""} {plan.price ? `— ₹${plan.price}` : ""}
                    </option>
                  ))}
                </select>
              </div>

              {/* New Expiry Date */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                  New Expiry Date
                </label>
                <input
                  type="date"
                  value={planChangeForm.new_expiry_date}
                  onChange={(e) => setPlanChangeForm((f) => ({ ...f, new_expiry_date: e.target.value }))}
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    border: "1px solid #cbd5e1",
                    borderRadius: 6,
                    fontSize: 13,
                    boxSizing: "border-box",
                    outline: "none",
                  }}
                />
              </div>

              {/* Credits / Alerts */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                  Credits (Alerts)
                </label>
                <input
                  type="number"
                  value={planChangeForm.alerts}
                  onChange={(e) => setPlanChangeForm((f) => ({ ...f, alerts: e.target.value }))}
                  placeholder="Enter credits"
                  min="0"
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    border: "1px solid #cbd5e1",
                    borderRadius: 6,
                    fontSize: 13,
                    boxSizing: "border-box",
                    outline: "none",
                  }}
                />
              </div>

              {/* Remark */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                  Remark
                </label>
                <textarea
                  rows={3}
                  value={planChangeForm.remark}
                  onChange={(e) => setPlanChangeForm((f) => ({ ...f, remark: e.target.value }))}
                  placeholder="Reason for plan change"
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    border: "1px solid #cbd5e1",
                    borderRadius: 6,
                    fontSize: 13,
                    boxSizing: "border-box",
                    outline: "none",
                    resize: "vertical",
                  }}
                />
              </div>

              {/* Actions */}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button
                  onClick={handleClosePlanChangeModal}
                  style={{
                    padding: "8px 20px",
                    borderRadius: 6,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    color: "#64748b",
                    cursor: "pointer",
                    fontSize: 13,
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitPlanChange}
                  disabled={planChangeLoading || !planChangeForm.new_plan_id || !planChangeForm.new_expiry_date || !planChangeForm.remark.trim()}
                  style={{
                    padding: "8px 22px",
                    borderRadius: 6,
                    border: "none",
                    background:
                      planChangeLoading || !planChangeForm.new_plan_id || !planChangeForm.new_expiry_date || !planChangeForm.remark.trim()
                        ? "#94a3b8"
                        : "#016551",
                    color: "#fff",
                    cursor:
                      planChangeLoading || !planChangeForm.new_plan_id || !planChangeForm.new_expiry_date || !planChangeForm.remark.trim()
                        ? "not-allowed"
                        : "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  {planChangeLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Update Subscription Modal */}
      {updateSubModal.open && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1400,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={handleCloseUpdateSubModal}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "100%",
              maxWidth: 640,
              boxShadow: "0 8px 32px rgba(4,52,58,0.2)",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{ background: "#04343a", padding: "14px 20px" }}>
              <p style={{ margin: 0, color: "#fff", fontWeight: 700, fontSize: 15 }}>Update Subscription</p>
            </div>

            <div style={{ padding: "20px 24px" }}>
              {/* Current Subscription Summary Row */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 8,
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: 8,
                  padding: "10px 14px",
                  marginBottom: 20,
                }}
              >
                {[
                  { label: "Subscription ID", value: updateSubModal.subscription?.sub_id },
                  { label: "Plan Name", value: updateSubModal.subscription?.plan_name },
                  { label: "Expiry Date", value: formatDate(updateSubModal.subscription?.expiry_date) },
                ].map(({ label, value }) => (
                  <div key={label} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0, fontSize: 10, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</p>
                    <p style={{ margin: "2px 0 0", fontSize: 13, fontWeight: 700, color: "#04343a" }}>{value || "—"}</p>
                  </div>
                ))}
              </div>

              {/* Form Grid */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px 16px", marginBottom: 20 }}>
                {/* Plan Dropdown */}
                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                    Plan
                  </label>
                  <select
                    value={updateSubForm.plan_id}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, plan_id: e.target.value }))}
                    disabled={plansLoading}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: 6,
                      fontSize: 13,
                      outline: "none",
                      background: plansLoading ? "#f8fafc" : "#fff",
                      color: "#1e293b",
                      boxSizing: "border-box",
                    }}
                  >
                    <option value="">{plansLoading ? "Loading plans..." : "— Select Plan —"}</option>
                    {activePlansList.map((plan) => (
                      <option key={plan.id} value={plan.id}>
                        {plan.plan_name || plan.name} {plan.plan_code ? `[${plan.plan_code}]` : ""} {plan.price ? `— ₹${plan.price}` : ""}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Start Date */}
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={updateSubForm.start_date}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, start_date: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: 6,
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                </div>

                {/* Next Billing Date */}
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                    Next Billing Date
                  </label>
                  <input
                    type="date"
                    value={updateSubForm.next_billing_date}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, next_billing_date: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: 6,
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                </div>

                {/* Expiry Date */}
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                    Expiry Date
                  </label>
                  <input
                    type="date"
                    value={updateSubForm.expiry_date}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, expiry_date: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: 6,
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                </div>

                {/* Credits */}
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 4 }}>
                    Credits
                  </label>
                  <input
                    type="number"
                    value={updateSubForm.credits}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, credits: e.target.value }))}
                    placeholder="Enter credits"
                    min="0"
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: 6,
                      fontSize: 13,
                      boxSizing: "border-box",
                      outline: "none",
                    }}
                  />
                </div>

                {/* Active */}
                <div style={{ gridColumn: "1 / -1", display: "flex", alignItems: "center", gap: 8 }}>
                  <input
                    id="update-sub-active"
                    type="checkbox"
                    checked={updateSubForm.active}
                    onChange={(e) => setUpdateSubForm((f) => ({ ...f, active: e.target.checked }))}
                    style={{ width: 16, height: 16, cursor: "pointer" }}
                  />
                  <label htmlFor="update-sub-active" style={{ fontSize: 13, color: "#1e293b", fontWeight: 600, cursor: "pointer" }}>
                    Active
                  </label>
                </div>
              </div>

              {/* Actions */}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button
                  onClick={handleCloseUpdateSubModal}
                  style={{
                    padding: "8px 20px",
                    borderRadius: 6,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    color: "#64748b",
                    cursor: "pointer",
                    fontSize: 13,
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmitUpdateSubscription}
                  disabled={updateSubLoading || !updateSubForm.plan_id || !updateSubForm.next_billing_date || !updateSubForm.expiry_date}
                  style={{
                    padding: "8px 22px",
                    borderRadius: 6,
                    border: "none",
                    background:
                      updateSubLoading || !updateSubForm.plan_id || !updateSubForm.next_billing_date || !updateSubForm.expiry_date
                        ? "#94a3b8"
                        : "#016551",
                    color: "#fff",
                    cursor:
                      updateSubLoading || !updateSubForm.plan_id || !updateSubForm.next_billing_date || !updateSubForm.expiry_date
                        ? "not-allowed"
                        : "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  {updateSubLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Cancel Mandate Modal */}
      <Dialog
        open={cancelMandateModal.open}
        onClose={() => !cancelLoading && setCancelMandateModal({ open: false, razorpay_subscription_id: "" })}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
      >
        <DialogTitle
          sx={{
            background: "#04343a",
            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
            py: 1.5,
            px: 2.5,
          }}
        >
          Cancel Mandate
        </DialogTitle>
        <DialogContent sx={{ pt: "20px !important", pb: 1 }}>
          <Typography sx={{ fontSize: 12, color: "#64748b", mb: 1.5 }}>
            Subscription ID:{" "}
            <strong style={{ color: "#1e293b" }}>
              {cancelMandateModal.razorpay_subscription_id}
            </strong>
          </Typography>
          <TextField
            label="Cancellation Reason"
            multiline
            minRows={3}
            fullWidth
            size="small"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            placeholder="Enter reason for cancellation..."
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: 13,
                "&.Mui-focused fieldset": { borderColor: "#016551" },
              },
              "& .MuiInputLabel-root.Mui-focused": { color: "#016551" },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setCancelMandateModal({ open: false, razorpay_subscription_id: "" })}
            disabled={cancelLoading}
            size="small"
            sx={{ color: "#64748b", textTransform: "none", fontSize: 13 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCancelMandate}
            disabled={cancelLoading}
            size="small"
            variant="contained"
            sx={{
              background: "#dc2626",
              textTransform: "none",
              fontSize: 13,
              fontWeight: 600,
              "&:hover": { background: "#b91c1c" },
              "&:disabled": { background: "#fca5a5" },
            }}
          >
            {cancelLoading ? "Cancelling..." : "Confirm Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )

}


export default UserDashboardHome;
